const breadcrumbs = () => {

    $('.breadcrumbs a').on('click', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        window.location = url;
    });

    $('.breadcrumbs .breadcrumb_last').on('click', function (e) {
        e.preventDefault();
    });


};

export default breadcrumbs;